import { render, staticRenderFns } from "./RendezVousTelemedecine.vue?vue&type=template&id=096b5ad6&scoped=true&"
import script from "./RendezVousTelemedecine.vue?vue&type=script&lang=js&"
export * from "./RendezVousTelemedecine.vue?vue&type=script&lang=js&"
import style0 from "./RendezVousTelemedecine.vue?vue&type=style&index=0&id=096b5ad6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "096b5ad6",
  null
  
)

export default component.exports